// Feature tier configuration for simplified experience
export interface FeatureTierConfig {
  hideBudget: boolean
  hideAnalytics: boolean
  hideTeam: boolean
  hideContracts: boolean
  hideAssessments: boolean
  hideSystemSettings: boolean
  hideAITools: boolean
  simplifiedSettings: boolean
}

// Default configuration for simplified experience (trainers/small gyms)
// BETA: All features unlocked for user feedback - will re-package after beta
export const SIMPLIFIED_FEATURES: FeatureTierConfig = {
  hideBudget: false,      // BETA: Show budget planning
  hideAnalytics: false,   // Keep basic analytics
  hideTeam: false,        // Keep team for multi-trainer
  hideContracts: false,   // BETA: Show contracts
  hideAssessments: false, // BETA: Show assessments
  hideSystemSettings: false, // BETA: Show system settings
  hideAITools: false,     // Keep AI for Elite tier
  simplifiedSettings: false // BETA: Full settings menu
}

// ATN as Elite tier demo client - BETA: All features unlocked
export const ATN_FEATURES: FeatureTierConfig = {
  hideBudget: false,      // BETA: Show budget planning
  hideAnalytics: false,
  hideTeam: false,
  hideContracts: false,   // BETA: Show contracts
  hideAssessments: false,
  hideSystemSettings: false, // BETA: Show system settings
  hideAITools: false,
  simplifiedSettings: false // BETA: Full settings menu
}

// Elite tier features - BETA: All features unlocked
export const ELITE_FEATURES: FeatureTierConfig = {
  hideBudget: false,      // BETA: Show budget planning
  hideAnalytics: false,
  hideTeam: false,
  hideContracts: false,   // BETA: Show contracts
  hideAssessments: false,
  hideSystemSettings: false, // BETA: Show system settings
  hideAITools: false,
  simplifiedSettings: false // BETA: Full settings menu
}

// Full facility features (enterprise)
export const FACILITY_FEATURES: FeatureTierConfig = {
  hideBudget: true, // Hidden for all users - feature not ready
  hideAnalytics: false,
  hideTeam: false,
  hideContracts: false,
  hideAssessments: false,
  hideSystemSettings: false,
  hideAITools: false,
  simplifiedSettings: false
}

// Get feature configuration based on organization settings
// BETA: All users get full features for feedback collection
export function getFeatureConfig(organizationType?: string, featureTier?: string): FeatureTierConfig {
  // BETA: Return full features for all users
  // TODO: Re-package tiers after beta based on user feedback
  return FACILITY_FEATURES
}